module.exports = __webpack_public_path__ + "static/media/12.09cc7b4b.jpg";